module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /Users/kny/EHG/ABY2/ABYTWO/abydos/ng-project/node_modules/core-js/modules/_fails.js
// module id = ../../../../core-js/modules/_fails.js
// module chunks = polyfills